import {
    createApp,
    defineAsyncComponent
} from "vue";

/////////////////////////////////////////////////////////////////////////////////////////////////// PLUGINS
// import CookiesMsg from './plugins/cookies-msg/index.js';
import SiteDrawer from "./plugins/site-drawer/index.js";

/////////////////////////////////////////////////////////////////////////////////////////////////// COMPONENTS
import CookiesBar from "./components/cookies-bar/index.vue";
import BgImage from "./components/bg-image/index.vue";
const BgVideo = defineAsyncComponent(() => import('./components/bg-video/index.vue'));
import ReservationForm from "./reservation-form.vue";
const ReservationPayment = defineAsyncComponent(() => import('./reservation-payment.vue'));
const Stripe = defineAsyncComponent(() => import('./components/stripe/index.vue'));
const Voucher = defineAsyncComponent(() => import('./voucher.vue'));
import bsModal from "bootstrap/js/dist/modal";
import vSelect from "vue-select";
const inputPhone = defineAsyncComponent(() => import('./components/input-phone/index.vue'));

const MenuGallery = defineAsyncComponent(() => import('./menu-gallery.vue'));
// const GoogleMap = defineAsyncComponent(() => import("./components/google-map/index.vue"));

/////////////////////////////////////////////////////////////////////////////////////////////////// MIXINS
import Animations from "./animations.js";

/////////////////////////////////////////////////////////////////////////////////////////////////// APP
import { devices } from "./imports/utils";

import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

import DatepickerInFullscreen from './directives/datepicker/index.js';
import { Fancybox } from "@fancyapps/ui";
Fancybox.bind("[data-fancybox]", {
    commonCaption: true,
    idle: false,
    Toolbar: {
        enabled: true,
        display: {
            left: [],
            right: ["close"],
        },
    },
});

createApp({
    mixins: [Animations],
    directives: {
        DatepickerInFullscreen
    },
    components: {
        CookiesBar,
        BgVideo,
        MenuGallery,
        ReservationForm,
        ReservationPayment,
        Stripe,
        Voucher
    },
    data() {
        return {
            scrollTop: 0,
            modals: [],
            showCookiesBar: true,
            isDevice: devices(),
            // viewportSize: viewportSize(),
            // menuOpen: false
        }
    },
    methods: {
        onScroll() {
            this.scrollTop = window.scrollY;
        },
        showModal(id) {

            if (this.siteDrawerOpen) {
                clearAllBodyScrollLocks();
            }

            const modalEl = document.getElementById(id);
            const modalIndex = this.modals.findIndex(element => element.id == id);

            if (modalIndex === -1) {
                const modalObject = new bsModal(modalEl, {
                    keyboard: id === 'modal-cookies' ? false : true
                });

                this.modals.push({
                    'id': id,
                    'object': modalObject
                });

                if (id === 'modal-reservation') {
                    modalEl.addEventListener('hidden.bs.modal', event => {
                        this.$refs['reservation-form'].resetForm()
                    });
                } else if (id === 'modal-voucher') {
                    modalEl.addEventListener('hidden.bs.modal', event => {
                        this.$refs['voucher-form'].resetForm()
                    });
                }

                modalObject.show();
            } else {
                this.modals[modalIndex].object.show();
            }
        },
        hideModal(id) {
            if (this.siteDrawerOpen) {
                const target = document.querySelector(".main-menu-wrapper");

                // console.log('disableBodyScroll')

                // disableBodyScroll(target, {
                //     reserveScrollBarGap: true
                // });
            }

            const modalIndex = this.modals.findIndex(element => element.id == id);
            this.modals[modalIndex].object.hide();
        },
        // toggleModal(id) {
        //     if (this.modals) {
        //         this.showModal(id);
        //     } else {
        //         this.hideModal();
        //     }
        // },
        $scrollTo(el, container) {
            let wrapper = document.querySelector(container) ?? window;
            // const top = el.getBoundingClientRect().top;

            // wrapper.scrollTo({
            //     top: top + 500,
            //     behavior: 'smooth',
            // });

            const resolveElement = (e) => {
                if (!e) return null;
                if (typeof e === 'string') return document.querySelector(e);
                return e instanceof Element ? e : null;
            }

            const distanceFromBody = (element) => {
                let top = 0;
                let el = element;
                while (el) {
                    top += el.offsetTop || 0;
                    el = el.offsetParent;
                }
                return top;
            }

            const targetEl = resolveElement(el);
            if (!targetEl) return;

            const elTop = distanceFromBody(targetEl);

            if (wrapper === window) {
                window.scrollTo({
                    top: elTop - 300,
                    behavior: 'smooth'
                });
            } else {
                // For an element container, calculate the element's position relative to the container
                const wrapperTop = distanceFromBody(wrapper);
                const scrollTarget = elTop - wrapperTop + wrapper.scrollTop;
                
                wrapper.scrollTo({
                    top: scrollTarget - 300,
                    behavior: 'smooth'
                });
            }
        }
    },
    created() {
        if (process.env.NODE_ENV === 'production') console.log('%c Coded By Freshdesign Team! ', 'background: #000; color: #c9ec01; padding: 10px; font-size: 13px;');

        window.addEventListener("scroll", this.onScroll, {
            passive: true
        });

        // window.addEventListener("resize", this.onResize, {
        //     passive: true
        // });

        // if (this.isDevice) document.querySelector("html").classList.add("device");
    },
    mounted() {
        if (this.$refs['cookies-bar']) {
            this.showCookiesBar = this.$refs['cookies-bar'].showCookiesBar;
        }
    },
    destroyed() {
        window.removeEventListener("scroll", this.onScroll)
        // window.removeEventListener("resize", this.onResize);
    }
})
    // .use(CookiesMsg)
    .use(SiteDrawer)
    .component("BgImage", BgImage)
    .component("vSelect", vSelect)
    .component("inputPhone", inputPhone)
    // .component("Popper", Popper)
    .mount("#app")